const AppTheme = {
    light: {
        textColor: "#000",
        backgroundColor: "#DAE0E2",
        cardBody:"#FFF",
        tableHeader:"rgba(108,117,125,.0627451)",
        testsmilbc: "rgba(32, 26, 162, 0.125)"
    },
    dark: {
        textColor: "#FFF",
        // backgroundColor: "#2F363F",
        backgroundColor: "rgb(22, 22, 37)",
        cardBody: "#DAE0E2",
        tableHeader: "rgb(30, 30, 48)",
        testsmilbc: "rgba(64,0,128,.31)"
    }
};

export default AppTheme;